import moment from "moment";
import { Cell } from "react-table";
import { CsItemModel } from "src/api/voc/voc-types";
import { BaseTooltip } from "src/components";
import DetailLink from "src/components/DetailLink";
import { PagePath } from "src/pages/product/details";
import { YmdFormat } from "src/utils";

const VocColumns = [
  {
    Header: "VoC 항목 ID",
    accessor: "id",
    width: 120,
    sticky: "left",
    Cell: ({ value }: Cell<CsItemModel>) => {
      const detailPath = `${PagePath.voc.detail.replace(":id", value)}`;

      return (
        <DetailLink to={detailPath} className="text-underline">
          {value}
        </DetailLink>
      );
    },
  },

  {
    Header: "유형",
    accessor: "csTypeName",
    width: 100,
    sticky: "left",
    Cell: ({ value }: Cell<CsItemModel>) => {
      return <p className="w-100 text-center">{value}</p>;
    },
  },
  {
    Header: "항목",
    accessor: "csItemName",
    width: 720,
    Cell: ({ value }: Cell<CsItemModel>) => {
      return <span className="text-start w-100">{value}</span>;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "modifiedDate",
    width: 160,
    Cell: ({ value }: Cell<CsItemModel>) => {
      return <p className="w-100 text-center">{value && moment(value).format(YmdFormat.FULL)}</p>;
    },
  },
];

export default VocColumns;
